module.exports = __webpack_public_path__ + "static/media/surveillance.b9bbce85.svg";